<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageAlt: page.headingImageAlt,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<breadcrumbs :breadcrumbs="page.breadcrumbs" :class="page.headingImage ? '' : 'no-slider'" />

		<main-content :title="page.title || page.header" :subtitle="page.subtitle" :content="page.content" />

		<section class="main-content contentblocks">
			<contentblock v-for="member in team" :key="member.ID">
				<template #contentblock-content>
					<h2>{{ member.header }}</h2>
					<div v-parse-links v-html="member.content" />
				</template>
				<template #contentblock-image>
					<picture>
						<source v-if="member.imageWebp" :srcset="member.imageWebp" type="image/webp" />
						<source :srcset="member.image" />
						<img loading="lazy" :src="member.image" :alt="member.imageAlt" class="object-fit" />
					</picture>
				</template>
			</contentblock>
			<div class="bottom-divider" />
		</section>

		<contentblocks
			v-if="page && page.contentblocks && page.contentblocks.length"
			:items="page.contentblocks"
			:content-blocks-content="page.sectionContentblocksContent"
			:content-blocks-subtitle="page.sectionContentblocksTitle"
		/>
		<frequently-asked-questions
			v-if="page && page.frequentlyAskedQuestion"
			:header="page.frequentlyAskedQuestion.header"
			:items="page.frequentlyAskedQuestion.faqitems"
		/>
		<pre-footer
			v-if="page && page.footerSection && page.footerSection.length"
			:footer-section="page.footerSection[0]"
		/>
		<newsletter
			v-if="page && page.showNewsletter"
			:header="defaults[locale].newsletter.title"
			:content="defaults[locale].newsletter.content"
			:button="defaults[locale].newsletter.button"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();

await fetchPage();
await fetchDefaults();

const { data: team } = await useWebsiteFetch('team', {
	query: { language: locale.value },
	key: `${locale.value}/team`,
});
</script>

<style lang="scss" scoped>
.contentblocks {
	position: relative;
	margin: 0;
	padding: 0;

	.bottom-divider {
		width: 100%;
		height: 75px;
		background: #d4c6b6;
	}
}

.bg-image {
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	width: 241px;
	height: 289px;
	margin: 0 auto;
	z-index: 1;
}

.row-header {
	padding: 50px 0;
	max-width: 1000px;
	position: relative;
	z-index: 2;
}
</style>
